module.exports = "/images/b454e98fa8fff252a22c6c0c2aeb6697.gif";